export function contentSecurityPolicy(options: {
  enableHsts: boolean;
  scriptHashes?: string[];
  scriptNonce?: string;
}): string {
  const parts = options.scriptNonce ? pageDirectives(options.scriptNonce) : apiDirectives(options.scriptHashes ?? []);
  if (options.enableHsts) parts.push('upgrade-insecure-requests');
  return parts.join('; ');
}

function apiDirectives(scriptHashes: string[]): string[] {
  const hashes = scriptHashes.map((hash) => `'sha256-${hash}'`);
  const scriptSrc = ["'self'", ...hashes].join(' ');
  return [
    "default-src 'self'",
    `script-src ${scriptSrc}`,
    "style-src 'self'",
    "img-src 'self' data:",
    "font-src 'self'",
    "connect-src 'self'",
    "object-src 'none'",
    "frame-src 'none'",
    "base-uri 'self'",
    "form-action 'self'",
    "frame-ancestors 'none'",
  ];
}

function pageDirectives(scriptNonce: string): string[] {
  const nonce = scriptNonce.replace(/[^A-Za-z0-9+/=]/g, '');
  return [
    "default-src 'self'",
    `script-src 'nonce-${nonce}' 'unsafe-inline' 'unsafe-eval' 'strict-dynamic' https: http:`,
    "style-src 'self' 'unsafe-inline' https:",
    "img-src 'self' data: https:",
    "font-src 'self' data: https:",
    "connect-src 'self' https:",
    'frame-src https:',
    "media-src 'self' https: blob:",
    "object-src 'none'",
    "base-uri 'self'",
    "form-action 'self'",
    "frame-ancestors 'none'",
  ];
}
